import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    create: 'Create a client',
    noResult: 'No result found',
    reset: 'Reset search',
    title: 'No client',
  },
  fr: {
    create: 'Créer un client',
    noResult: 'Aucun résultat',
    reset: 'Réinitialiser la recherche',
    title: 'Aucun client',
  },
});

export default locales;
